import { useState } from 'react';
import { useSetup } from '../api/auth.js';
import { Button, Card, ErrorNote, Input, Label } from '../components/ui.js';

/** First-run wizard: shown while the instance has no users at all. */
export function SetupPage({ panelName }: { panelName: string }) {
  const setup = useSetup();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [localError, setLocalError] = useState<string | null>(null);

  const onSubmit = (e: { preventDefault(): void }) => {
    e.preventDefault();
    if (password !== confirm) {
      setLocalError('Passwords do not match');
      return;
    }
    setLocalError(null);
    setup.mutate({ name, email, password });
  };

  return (
    <div className="flex h-full items-center justify-center bg-slate-50 p-6 dark:bg-slate-950">
      <div className="w-full max-w-md">
        <div className="mb-8 flex flex-col items-center gap-3 text-center">
          <div className="flex size-12 items-center justify-center rounded-xl bg-brand-600 text-lg font-bold text-white">
            CP
          </div>
          <div>
            <h1 className="text-xl font-semibold">Welcome to {panelName}</h1>
            <p className="mt-1 text-sm text-slate-500 dark:text-slate-400">
              Create the administrator account to finish installation.
            </p>
          </div>
        </div>
        <Card className="p-6">
          <form onSubmit={onSubmit} className="space-y-4">
            <div>
              <Label htmlFor="name">Your name</Label>
              <Input id="name" required value={name} onChange={(e) => setName(e.target.value)} />
            </div>
            <div>
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                autoComplete="email"
                required
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input
                id="password"
                type="password"
                autoComplete="new-password"
                required
                minLength={12}
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />
              <p className="mt-1 text-xs text-slate-500 dark:text-slate-400">At least 12 characters.</p>
            </div>
            <div>
              <Label htmlFor="confirm">Confirm password</Label>
              <Input
                id="confirm"
                type="password"
                autoComplete="new-password"
                required
                value={confirm}
                onChange={(e) => setConfirm(e.target.value)}
              />
            </div>
            {(localError || setup.error) && <ErrorNote error={localError ?? setup.error} />}
            <Button type="submit" className="w-full" loading={setup.isPending}>
              Create administrator
            </Button>
          </form>
        </Card>
      </div>
    </div>
  );
}
